import { render, staticRenderFns } from "./XhBusinessStatus.vue?vue&type=template&id=fcb7198e&scoped=true"
import script from "./XhBusinessStatus.vue?vue&type=script&lang=js"
export * from "./XhBusinessStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb7198e",
  null
  
)

export default component.exports